import { render, staticRenderFns } from "./SchoolBus2.vue?vue&type=template&id=8aaee2fc&scoped=true&"
import script from "./SchoolBus2.vue?vue&type=script&lang=js&"
export * from "./SchoolBus2.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBus2.vue?vue&type=style&index=0&id=8aaee2fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaee2fc",
  null
  
)

export default component.exports